import { ReactNode } from 'react'
import {
  BANNER_HEIGHT,
  CampaignBanner,
} from 'src/features/campaignBanner/CampaignBanner'
import { useCampaignBannerDismissal } from 'src/features/campaignBanner/campaignBannerDismissal'
import { Campaign } from 'src/features/campaignBanner/parseCampaigns'
import { useQueryCampaigns } from 'src/features/campaignBanner/useQueryCampaigns'
import { useBannerHeight } from 'src/hooks/useBannerHeight'

/**
 * 掲載中のキャンペーンがあれば、children の上にバナーを表示する。
 *
 * 掲載するかどうかはキャンペーン配信 API が決めるため、フロント側に掲載期間や
 * キャンペーンごとの設定は持たない。取得できなかった場合はバナーを出さない。
 */
export const CampaignBannerWrapper = (props: { children: ReactNode }) => {
  const { children } = props

  const { data: campaign } = useQueryCampaigns()

  return (
    <>
      {campaign && <CampaignBannerArea campaign={campaign} />}
      {children}
    </>
  )
}

/**
 * 閉じられている場合は何も描画しない。
 */
const CampaignBannerArea = (props: { campaign: Campaign }) => {
  const { campaign } = props

  const { isDismissed, dismiss } = useCampaignBannerDismissal(
    campaign.campaignId,
  )

  useBannerHeight(isDismissed ? undefined : BANNER_HEIGHT)

  if (isDismissed) return null

  return <CampaignBanner campaign={campaign} onClose={dismiss} />
}
